// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".data-types-label_f7b5570a{font-family:PitchBookFont,'Helvetica','Arial',sans-serif;font-size:1rem;line-height:1;letter-spacing:normal;color:#6185a6;font-stretch:normal}", ""]);
// Exports
export var dataTypesLabel = "data-types-label_f7b5570a";
export default ___CSS_LOADER_EXPORT___;
